export function genBuildFields<T extends object>(object: T, keys: string[]) {
  return Object.entries(object).reduce((acc, [key, value]) => {
    if (keys.includes(key)) acc[key as keyof typeof acc] = value;
    return acc;
  }, {} as T);
}
